import { PDFResponse } from 'api/action';
import { postRequest as post } from '../HttpMethods';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { useNotification } from '@refinedev/core';
import * as Sentry from '@sentry/react';

interface CreateReportParams {
  path: string;
  params: any;
  functionName: string;
}

export const createReport = async ({
  path,
  params,
  functionName,
}: CreateReportParams): Promise<PDFResponse> => {
  try {
    const data: PDFResponse = await post('QBilling', path, params);
    if (!data) {
      throw new Error(`${functionName} Failed`);
    }
    return data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export const useCreateReport = (): UseMutationResult<PDFResponse> => {
  const { open } = useNotification();
  return useMutation({
    mutationFn: createReport,
    onError: (error: Error) => {
      open({
        message: error.message,
        type: 'error',
      });
    },
    onSuccess: () => {
      open({
        message:
          'Your report is being created. We will notify you via email when it is ready!',
        type: 'success',
      });
    },
    retry: 0,
  });
};
